module.exports = __webpack_public_path__ + "img/elim-christmas-finale.0fd3d220.jpeg";